import { Link } from "react-router-dom";
import { useEffect, useState } from "react";

function Content_index1({ data }) {
  const [slideContent, setSlideContent] = useState("");
  const [slideText, setslideText] = useState("");
  const [title, setTitle] = useState("");
  const [color, setColor] = useState("");

  useEffect(() => {
    if (data) {
      setSlideContent(data.spotlites[0].title);
      setslideText(data.spotlites[0].text);
    }
  }, [data]);


  useEffect(() => {
    if (slideContent) {
      let word1 = slideContent.split(" ");
      setTitle(word1[0]);
      setColor(word1[1]);
      var sentence = slideText;
      var ss = sentence.split(" ");
      ss[3] = "<span style='color: rgb(41, 197, 51);'>" + ss[3] + "</span>";
      var replacedSentence = ss.join(" ");
      document.getElementById("colorC").innerHTML = replacedSentence;
    }
  }, [slideContent]);


  return (
    <div className="contentIndex1">
      <h2 className="text-center">
        {title} <span style={{ color: "#29c533" }}>{color}</span>
        <br />
        <span id="colorC">{/* {slideText} */}</span>
      </h2>
      <div className="cta text-center">
        <Link to="menu" className="order-food">
          سفارش غذا
        </Link>
        {/* <a href="#!" className="guid">
                    <i className="fas fa-play-circle"></i>
                    نحوه سفارش
                </a> */}
      </div>
    </div>
  );
}

export default Content_index1;
